import React from 'react';
import { useTranslation } from 'react-i18next';

const RequirementsSection = () => {
  const { t } = useTranslation('latvia');

  const requirements = [
    {
      icon: 'ri-user-line',
      title: t('detail.requirements.1.title'),
      description: t('detail.requirements.1.desc'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('detail.requirements.2.title'),
      description: t('detail.requirements.2.desc'),
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: t('detail.requirements.3.title'),
      description: t('detail.requirements.3.desc'),
    },
    {
      icon: 'ri-file-list-3-line',
      title: t('detail.requirements.4.title'),
      description: t('detail.requirements.4.desc'),
    },
  ];

  return (
    <section className="py-8 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-16">
          <h2 className="text-lg md:text-4xl font-bold text-gray-900 mb-1.5 md:mb-4 font-serif">
            {t('detail.requirements.title')} <strong>{t('detail.requirements.titleBold')}</strong>
          </h2>
          <p className="text-xs md:text-lg text-gray-600 max-w-2xl mx-auto">
            {t('detail.requirements.description')}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 md:gap-8">
          {requirements.map((req, index) => (
            <div
              key={index}
              className="bg-white rounded-lg md:rounded-xl p-3 md:p-6 shadow-md md:shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="w-8 h-8 md:w-14 md:h-14 flex items-center justify-center bg-gradient-to-br from-gold-400 to-gold-600 rounded-lg md:rounded-xl mb-2 md:mb-4">
                <i className={`${req.icon} text-sm md:text-2xl text-white`}></i>
              </div>
              <h3 className="text-xs md:text-lg font-bold text-gray-900 mb-0.5 md:mb-2">{req.title}</h3>
              <p className="text-[10px] leading-relaxed md:text-sm text-gray-600">{req.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RequirementsSection;